<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <SellProductFiltersComponent
                    ref="sell-product-search"
                    @searchPressed="productRestockAlertShop"
                    @shopLoaded="productRestockAlertShop"
                    :enableFieldType="false"
                    :showErrors="true"
                    :showAvgSell="true"
                    :showShops="true"
                    preselectFamily
                ></SellProductFiltersComponent>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col>
                <div>
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="data"
                        :loading="loading"
                        item-key="cod_articolo"
                        class="elevation-1"
                        :items-per-page="50"
                        show-select
                        :footer-props="{
                            'items-per-page-options': [50, 100, 200, 500, -1],
                        }"
                        dense
                    >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-row dense>
                                    <v-col cols="2">
                                        <v-text-field
                                            dense
                                            type="number"
                                            outlined
                                            label="Giorni riordino"
                                            v-model="reorder_days"
                                            @input="setHeaders"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            dense
                                            outlined
                                            v-model="desc_search"
                                            clearable
                                            @input="filterDesc"
                                            label="Descrizione"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-checkbox
                                            dense
                                            v-model="filtra_riordino"
                                            @change="filtraRiordino"
                                            label="Filtra riordino"
                                        >
                                        </v-checkbox>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-checkbox
                                            dense
                                            v-model="flag_riordino"
                                            @change="
                                                flag_riordino != flag_riordino;
                                                setHeaders();
                                            "
                                            label="Calcolo Riordino"
                                        >
                                        </v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    small
                                    dark
                                    class="mb-2 mr-2"
                                    @click="exportData()"
                                >
                                    Esporta
                                    <v-icon small> download </v-icon>
                                </v-btn>

                                <v-btn
                                    color="secondary"
                                    small
                                    dark
                                    class="mb-2"
                                    @click="exportDataTotale()"
                                >
                                    Esporta Totale
                                    <v-icon small> download </v-icon>
                                </v-btn>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.immagine="{ item }">
                            <v-img
                                :src="imagePath(item.cod_articolo)"
                                width="80"
                                height="80"
                            ></v-img>
                        </template>
                        <template v-slot:item.cod_articolo="{ item }">
                            <router-link
                                target="_blank"
                                :to="{
                                    name: 'product',
                                    query: {
                                        id: item.cod_articolo,
                                    },
                                }"
                            >
                                {{ item.cod_articolo }}
                            </router-link>
                        </template>
                        <template v-slot:item.tot_sell_value="{ item }">
                            {{ item.tot_sell_value | formatEuro }}
                        </template>
                        <template v-slot:item.prezzo_netto="{ item }">
                            {{ item.prezzo_netto | formatEuro }}
                        </template>
                        <template
                            v-slot:item.prezzo_netto_giornaliero="{ item }"
                        >
                            {{ item.prezzo_netto_giornaliero | formatEuro }}
                        </template>
                        <template v-slot:item.prezzo_netto_tot="{ item }">
                            {{ item.prezzo_netto_tot | formatEuro }}
                        </template>
                        <template
                            v-slot:item.guadagno_medio_giornata_lordo="{ item }"
                        >
                            {{
                                item.guadagno_medio_giornata_lordo | formatEuro
                            }}
                        </template>

                        <template v-slot:item.out_of_stock_days="{ item }">
                            <v-chip
                                :color="getColor(item.out_of_stock_days)"
                                dark
                            >
                                {{ item.out_of_stock_days }}
                            </v-chip>
                        </template>

                        <template #item.giorno_riordino="{ item }">
                            {{
                                calcoloGiornoRiordino(
                                    item.qty_media_giornaliera
                                )
                            }}
                        </template>
                    </v-data-table>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped lang="scss"></style>
<script>
import requests from "../../requests";
import SellProductFiltersComponent from "../../components/SellProductFiltersComponent.vue";
import _ from "lodash";
import $ from "jquery";

export default {
    name: "product-restock-alert",
    components: { SellProductFiltersComponent },
    computed: {},
    data: () => {
        return {
            headers: [],
            selected: [],
            loading: false,
            shops: [],
            data: [],
            original_data: [],
            order: {},
            reorder_days: 60,
            desc_search: "",
            flag_riordino: false,
            filtra_riordino: false,
        };
    },

    mounted() {
        console.log("Product Sell Mounted.");
        let filters = this.$refs["sell-product-search"].getFilters();
        this.setHeaders();
        //this.productRestockAlertShop(filters);
    },
    methods: {
        filtraRiordino(checked) {
            if (checked) {
                this.data = _.filter(this.original_data, (o) => {
                    return o.lotto_riordino > 0;
                });
            } else this.data = this.original_data;
        },
        imagePath(prodId) {
            if (!this.error) {
                let normId = prodId.replace("/", "_") + ".jpg";
                return "/images/catalog/lower/" + normId;
            } else {
                return "no_image.jpg";
            }
        },
        filterDesc(str) {
            this.data = _.filter(this.original_data, (o) => {
                if (_.isEmpty(str)) return true;
                return _.lowerCase(o.ar_descr).includes(_.lowerCase(str));
            });
        },
        productRestockAlertShop(filters) {
            filters["reorder_days"] = this.reorder_days;
            this.loading = true;
            requests.productRestockAlertShop(filters).then((res) => {
                this.data = res.data;
                this.original_data = _.cloneDeep(res.data);
                this.loading = false;
            });
        },
        getColor(days) {
            if (days <= 30) return "red";
            else if (days > 30 && days <= 90) return "orange";
            else return "green";
        },
        exportData() {
            let filters = this.$refs["sell-product-search"].getFilters();
            filters["reorder_days"] = this.reorder_days;
            filters["selected"] = _.map(this.selected, "cod_articolo");
            window.open(
                "/api/product-restock-alert-shop-export?" + $.param(filters),
                "_blank"
            );
        },

        exportDataTotale() {
            let filters = this.$refs["sell-product-search"].getFilters();
            filters["reorder_days"] = this.reorder_days;
            filters["selected"] = _.map(this.selected, "cod_articolo");
            window.open(
                "/api/product-restock-alert-shop-tot-export?" +
                    $.param(filters),
                "_blank"
            );
        },
        calcoloGiornoRiordino(qty_media_giornaliera) {
            return Math.ceil(
                parseInt(this.reorder_days) * parseFloat(qty_media_giornaliera)
            );
        },

        setHeaders() {
            let a = [
                {
                    text: "Immagine",
                    value: "immagine",
                },
                {
                    text: "Cod Art",
                    sortable: true,
                    value: "cod_articolo",
                },
                {
                    text: "Cod Forn",
                    sortable: true,
                    value: "xx_codarfo",
                },
                {
                    text: "Desc",
                    sortable: true,
                    value: "ar_descr",
                },
                {
                    text: "Totale Venduto",
                    value: "tot_sell_value",
                },
                { text: "Qty Venduta Totale", value: "tot_qty" },
                {
                    text: "Med lorda giornata",
                    value: "guadagno_medio_giornata_lordo",
                },
                {
                    text: "Med venduta day",
                    value: "qty_media_giornaliera",
                },
                { text: "Giacenza", value: "tot_giacenze" },
                { text: "Lotto Riordino", value: "lotto_riordino" },
                { text: "Giacenza Sede", value: "tot_giacenze_sede" },
            ];
            if (!this.flag_riordino) {
                a.push({
                    text: "Rifornimento (" + this.reorder_days + " gg)",
                    value: "giorno_riordino",
                });
            } else {
                a.push({
                    text: "Rifornimento",
                    value: "num_riordino",
                });
            }
            a.push(
                ...[
                    {
                        text: "Prev. Out Of Stock (gg)",
                        value: "out_of_stock_days",
                        align: "center",
                    },
                    { text: "Cod Fornitore", value: "ar_codforn" },
                    { text: "Bar Code", value: "bc_code" },
                    { text: "Netto Unit.", value: "prezzo_netto" },
                    {
                        text: "Netto Medio Giorn.",
                        value: "prezzo_netto_giornaliero",
                    },
                    { text: "Netto Tot", value: "prezzo_netto_tot" },
                ]
            );
            this.headers = a;
        },
    },
    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    },
};
</script>
